import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/autoscan/autoscan-client.tsx");
